import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations, DEFAULT_LANG, LANGS } from "./translations";

const I18nContext = createContext({ lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        const saved = typeof localStorage !== "undefined" ? localStorage.getItem("lang") : null;
        return saved && LANGS.includes(saved) ? saved : DEFAULT_LANG;
    });

    const setLang = useCallback((l) => {
        if (!LANGS.includes(l)) return;
        setLangState(l);
        try {
            localStorage.setItem("lang", l);
        } catch (err) {
            console.error("[i18n] Failed to persist language:", err);
        }
    }, []);

    useEffect(() => {
        if (typeof document !== "undefined") document.documentElement.lang = lang;
    }, [lang]);

    const t = useCallback((key, vars) => {
        const entry = translations[key];
        if (!entry) return key;
        let out = entry[lang] || entry[DEFAULT_LANG] || key;
        if (vars) Object.entries(vars).forEach(([k, v]) => {
            out = out.replaceAll(`{${k}}`, String(v));
        });
        return out;
    }, [lang]);

    const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useT() {
    return useContext(I18nContext);
}
